module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.locked) ? _c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.showModal = !_vm.showModal
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.field.button) + "\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.locked && _vm.imageDataUrl) ? _c('button', {
    staticClass: "btn default",
    attrs: {
      "id": _vm.field.name + 'btn-remove'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeUploadedImage(_vm.field.name)
      }
    }
  }, [_vm._v("Remove image\n  ")]) : _vm._e(), _vm._v(" "), _c('vue-image-crop-upload', {
    attrs: {
      "field": _vm.field.name,
      "noRotate": false,
      "width": 300,
      "height": 300,
      "lang-type": "en",
      "lang-ext": _vm.languageExtend,
      "img-format": "png"
    },
    on: {
      "crop-success": _vm.cropSuccess,
      "crop-upload-success": _vm.cropUploadSuccess,
      "crop-upload-fail": _vm.cropUploadFail
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "imagecrop-preview",
    attrs: {
      "src": _vm.showInitial ? _vm.initialUrl : _vm.imageDataUrl,
      "id": _vm.field.name
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d6a039f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/ImageRender.vue
// module id = 1689
// module chunks = 1